import { Component, Input, OnInit } from '@angular/core';
import { DiscussionService } from '../../../shared-service/services/discussion.service';

@Component({
  selector: 'mcq-post',
  templateUrl: './mcq.component.html',
  styleUrls: ['./mcq.component.css']
})
export class McqComponent implements OnInit {

  @Input()
  post:any;

  userSelectedMCQOption='';
  isMCQAnswered:boolean=false;
  forumPercentageData:any;
  mscqOptions=[];
  userId='';
  userData:any;

  constructor(  private discussionService: DiscussionService,) {
  }

  ngOnInit() {
    if (localStorage.getItem('userData')){
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.userId = this.userData.user_id;
    }
    this.getSplitAnswers();
    if(this.post && this.post.forum_mcq_ans_data && this.post.forum_mcq_ans_data.mcq_ans_data) {
      if(this.userId && this.post.logged_in_user_answers) {
        this.isMCQAnswered = true;
        this.userSelectedMCQOption = this.post.logged_in_user_answers + '';
      }
      this.forumPercentageData = this.post.forum_mcq_ans_data;
      this.getPercentageCalculator();
    }
  }

  getSplitAnswers() {
    let opts = this.post.forum_mcq_choices.split(',');
    opts.forEach(opt => {
      this.mscqOptions.push({
        option:opt,
        percent:'0%'
      })
    })
  }

  optionClickEvent(optionSelected) {
    this.userSelectedMCQOption = optionSelected+'';
    this.saveMCQOption();
  }

  undoOptionClickEvent() {
    this.userSelectedMCQOption = '';
    this.isMCQAnswered = false;
  }

  getPercentageCalculator() {
    if(this.forumPercentageData && this.forumPercentageData.mcq_ans_data) {
      this.forumPercentageData.mcq_ans_data.forEach(optionAnswered => {
          this.mscqOptions.forEach((opt, ind) => {
            if(ind+1 == optionAnswered.answer) {
              opt.percent = optionAnswered.answer_percentage+'%';
              return false;
            }
          });
      });
    }
  }

  saveMCQOption() {
    const formData = new FormData();
    let data = {
      forum_id:this.post.forum_id,
      option_id:this.userSelectedMCQOption,
      user_id:this.userId
    };
    formData.append('user_id', data['user_id']);
    formData.append('option_id', data['option_id']);
    formData.append('forum_id', data['forum_id']);
    this.discussionService.saveMCQAnswer(formData).subscribe((result:any) => {
      if(result && result.data) {
        this.forumPercentageData = result.data;
        this.getPercentageCalculator();
        this.isMCQAnswered = true;
      }
    });
  }

}
